import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import SelectInput from '../input/select'
import TestingFilms from './testing_films'
import TestingTiers from './testing_tiers'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'
import { Button } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const FPVTestingEditForm = observer(({ state }) => {
  const entity = state.cv.record
  const errors = state.cv.errors
  const working = state.working
  const tester = entity.has('tester_id') && entity.get('tester_id')
  const testerPlatform = entity.has('platform_auth0') && entity.get('platform_auth0')
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(linkConst.LINK_FPVTESTING, 'w')
  const title = state.__(linkConst.LINK_FPVTESTING_TITLE).concat(defaultConst.HTML_DIVIDER) + (entity.get('id')
    ? (entity.has('tester_email') ? entity.get('tester_email') : state.__(defaultConst.TITLE_EDIT))
    : state.__(defaultConst.TITLE_CREATE))

  const loadTransactions = (e) => {
    e.target.blur()
    new Promise((resolve) => {
      resolve(state.cv.loadTransactions(entity))
    }).then((result) => {
      result
        ? state.addMessage(state.__('Transactions were loaded'), 'info', 2000)
        : state.addMessage(!tester || !testerPlatform
          ? state.__('"Tester\'s Auth0 ID" or "Auth0 platform" is missing')
          : state.__('There is nothing to load'),
        'warning', 4000)
      state.workingUpdate(false)
    })
  }

  const headSubFilm = {
    subHead: [
      ['tier', 'Tier'],
      ['platform', 'Platform'],
      ['periodTimeUnit', 'Time unit'],
      ['periodLength', 'Length']
    ],
    filmHead: [
      ['slug', 'Slug'],
      ['platform', 'Platform'],
      ['type', 'Type'],
      ['validTo', 'Valid to']
    ]
  }
  const testingFilms = (headtitle, titles, subscription = false) => {
    const listItem = []
    const transactions = state.cv.userTransactions && Object.keys(state.cv.userTransactions)
      .sort()
      .reduce(function (val, key) {
        val[key.toLowerCase()] = state.cv.userTransactions[key]
        return val
      }, {})

    for (let key in transactions) {
      transactions[key].map(i => {
        if (i.validToTimestamp) {
          i.validTo = moment.unix(i.validToTimestamp).format(defaultConst.DATE_FORMAT)
        }
        if (subscription && i.subscription) {
          listItem.push(Object.assign({}, i, i.subscription))
        } else if (!subscription && !i.subscription) {
          listItem.push(i)
        }
      })
    }

    return (<div>
      <h5 className='card-title'>{state.__(headtitle)} &nbsp;
        <small>({listItem.length}x)</small>
      </h5>
      <table className='table table-sm'>
        <thead>
          <tr>{titles.map((i, k) => <th key={k}>{i[1] || i[0]}</th>)}</tr>
        </thead>
        <tbody>
          {listItem && listItem.length
            ? listItem.map((j, k) =>
              <tr key={k}>{titles.map((i, key) =>
                <td key={key} style={key === 0 ? { width: '40%' } : {}}>
                  <span>{j[i[0]] || '-'}</span>
                </td>
              )}</tr>)
            : <tr><td>{state.__('EMPTY')}</td></tr>
          }
        </tbody>
      </table>
    </div>)
  }

  return (
    <div>
      <Helmet title={title} />
      <div className='row'>
        <div className='col-sm-12 col-md-6 col-lg-6'>
          <TextInput label={state.__('tester\'s Auth0 ID')} attr={'tester_id'}
            record={entity} onChange={updateField} errors={errors} disabled={disabled} />
          <SelectInput
            attr={'platform_auth0'}
            label={state.__('Auth0 platform')}
            labelattr='text'
            onChange={updateField}
            optionsattr={'FlyPrivatePlatformsAuth0'}
            optionsrecord={state.options}
            record={entity}
            valueattr='value'
            errors={errors} />
          <Button bsStyle='info' onClick={loadTransactions} style={{ marginBottom: '0.8em' }}
            disabled={working}>
            {!working
              ? <span className='glyphicon glyphicon-cloud-download' />
              : <span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />}
            &nbsp;{state.__('Load tester\'s transactions')}{working ? '...' : ''}
          </Button>
          <SelectInput
            attr={'tester_group'}
            label={state.__('group')}
            labelattr='text'
            onChange={updateField}
            optionsattr={'TestingGroups'}
            optionsrecord={state.options}
            record={entity}
            valueattr='value'
            errors={errors} />
          <TextInput label={state.__('tester e-mail')} attr={'tester_email'}
            record={entity} onChange={updateField} errors={errors} disabled={disabled} />
          <TextInput label={state.__('tester name')} attr={'tester_name'}
            record={entity} onChange={updateField} errors={errors} disabled={disabled} />
          <TextInput label={state.__('transaction ID')} attr={'trans_id'}
            record={entity} onChange={updateField} errors={errors} disabled={disabled} />
          <TextInput label={state.__('order ID')} attr={'order_id'}
            record={entity} onChange={updateField} errors={errors} disabled={disabled} />
          <SelectInput
            attr={'platform'}
            label={state.__('Platform for saving into plans/films')}
            labelattr='text'
            onChange={updateField}
            optionsattr={'FlyPrivatePlatforms'}
            optionsrecord={state.options}
            record={entity}
            valueattr='value'
            errors={errors} />
        </div>
        <div className='col-sm-12 col-md-6 col-lg-6'>
          <TestingTiers store={state} />
          {testingFilms('List of the subscriptions', headSubFilm.subHead, true)}
          {working ? <div>&nbsp;<span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' /></div> : ''}
          <br />&nbsp;
          <TestingFilms store={state} />
          {testingFilms('List of films', headSubFilm.filmHead)}
          {working ? <div>&nbsp;<span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' /></div> : ''}
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12'><br />
          <p className='alert alert-warning'>
            <strong>{state.__('Beware!')}</strong>&nbsp;
            {state.__('Saving saves the transactions also into the DynamoDB database. Existing records are NOT overwritten.')}
          </p>
          <p className='alert alert-warning'>
            <strong>{state.__('Beware!')}</strong>&nbsp;
            {state.__('Deleting a user will also delete his transactions in the DynamoDB.')}
          </p>
          <p className='alert alert-warning'>
            <strong>{state.__('Beware!')}</strong>&nbsp;
            {state.__('Each new plans/films will have a platform according to the fileld "Platform for saving into plans/film".')}
          </p>
        </div>
      </div>
    </div>
  )
})
FPVTestingEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const FPVTestingEditView = ({ store }) => {
  if (!store.hasRight(linkConst.LINK_FPVTESTING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }
  return (
    <EditView
      store={store.cv}
      enabled={store.hasRight(linkConst.LINK_FPVTESTING, 'w')}
      onReturn2list={store.onReturn2list.bind(store)}>
      <FPVTestingEditForm state={store} />
    </EditView>
  )
}
FPVTestingEditView.propTypes = {
  store: PropTypes.object.isRequired
}

export default FPVTestingEditView
